import { CdkPortalOutletAttachedRef, ComponentPortal, Portal } from '@angular/cdk/portal';
import { Component, ComponentRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { ShipstationService } from 'src/app/services/shipstation.service';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { ShipstationConnectionDetailsComponent } from './shipstation-connection-details/shipstation-connection-details.component';
import { ShipstationNewConnectionComponent } from './shipstation-new-connection/shipstation-new-connection.component';

@Component({
  selector: 'app-ship-station-connection',
  templateUrl: './ship-station-connection.component.html',
  styleUrls: ['./ship-station-connection.component.scss']
})
export class ShipStationConnectionComponent implements OnInit, OnDestroy {
  @ViewChild('panel') panel: MatExpansionPanel;
  selectedPortal: Portal<any>;
  @Input() connections: any;
  @Output() private refresh: EventEmitter<any> = new EventEmitter<any>();
  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private shipstationService: ShipstationService) { }

  ngOnInit(): void {
  }

  form = this.fb.group({
    accessKey: ["", [Validators.required]],
    secretKey: ["", [Validators.required]],
  });

  openAddConnection(event: MouseEvent) {
    event.stopPropagation();
    if (!this.selectedPortal) {
      this.selectedPortal = new ComponentPortal(ShipstationNewConnectionComponent);
    } else {
      this.selectedPortal = null;
    }
  }

  attach(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;
    if (ref.instance.close) {
      ref.instance.close
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.selectedPortal = null;
        });
    }
    if (ref.instance.saved) {
      ref.instance.saved.pipe(takeUntil(this.destroy$)).subscribe((response) => {
        if (response) {
          this.refresh.emit(response);
          this.selectedPortal = null;
        } else {
          this.panel.open();
        }
      });
    }
  }

  cancelEvent = (event: MouseEvent) => {
    event.stopPropagation();
  }

  showDetails() {
    this.dialog
      .open(ShipstationConnectionDetailsComponent, {
        width: "600px",
        data: {
          title: "Shipstation Details",
          details: this.connections
        },
      }).afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

      });
  }

  remove() {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Remove ShipStation Account",
          message: "Are you sure you want to remove this ShipStation Account?",
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(
    filter((e) => e === "Confirm"),
    switchMap(() => this.shipstationService.remove().pipe(takeUntil(this.destroy$)))
  )
   .subscribe({
        next: (response) => {
          this.refresh.emit(response);
        },
         error: (error) => {
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: error.error.error,
                action: 'Dismiss',
                type: 'error',
              },
            });
       }
  });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

